module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Right-circle-0b836b48db4048eb4ffcf22267cc301c.svg";